<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { useAbility } from "@casl/vue";
import { definePage } from "unplugin-vue-router/runtime";
import Loading from "@/components/shared/Loading.vue";
import MyDsosTable from "@/components/models/practice/table/MyDsosTable.vue";
import { useCanAccessOfficesManagement } from "@/composables/shared/useSectionPermissions";
import { useDsoTeam } from "@/composables/shared/useMyOrganization";

definePage({
  meta: {
    title: "generic.fields.sections.persons",
    checkPrivileges: () => {
      const { can } = useAbility();
      return (
        useCanAccessOfficesManagement().value &&
        can($permActions.READ, $permSubjects.PRACTICE__PRACTICESTAFF)
      );
    },
  },
});

const { t } = useI18n();
const { msosQuery, isList, isEmpty } = useDsoTeam();
</script>

<template>
  <div class="tw:pb-4! tw:sm:pb-6!">
    <div
      v-if="isEmpty"
      class="tw:text-center tw:text-sm tw:text-on-surface/50 tw:py-16!"
    >
      {{ t("generic.messages.noEntity", { entity: t("generic.entity.dso") }) }}
    </div>

    <Loading
      v-else-if="!isList"
      :size="32"
      class="tw:my-6!"
    />

    <my-dsos-table
      v-else
      :query="msosQuery"
      target="team"
    />
  </div>
</template>
